import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorPrimaryColorFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorPrimaryColorField: FC<CryptorPrimaryColorFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="primaryColor"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Couleur primaire"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorPrimaryColorField;
